import React, { useContext } from 'react';
import classNames from 'classnames';
import EnterpriseSuggestedActions from 'components/EnterpriseSuggestedActions';
import EnterpriseContext from '../../providers/Enterprise/Enterprise.context';

import './RwcSuggestedActions.styles.scss';

type RwcSuggestedActionsProps = {
  className?: string;
};

const RwcSuggestedActions: React.FC<RwcSuggestedActionsProps> = (props) => {
  const { className } = props;

  const { enterprise } = useContext(EnterpriseContext);

  const classes = classNames('rwc-suggested-actions', className);

  return (
    <div className={classes}>
      <EnterpriseSuggestedActions enterpriseId={enterprise?._id} />
    </div>
  );
};

export default RwcSuggestedActions;
